<template>
  <div class="vue-load-image">
    <slot
      v-if="status === 'loaded'"
      name="image"
    />
    <slot
      v-else-if="status === 'failed'"
      name="error"
    />
    <slot
      v-else-if="status === 'loading'"
      name="preloader"
    />
  </div>
</template>

<script>
import throttle from 'lodash-es/throttle';

const Status = {
  PENDING: 'pending',
  LOADING: 'loading',
  LOADED: 'loaded',
  FAILED: 'failed'
}

export default {
  data() {
    return {
      status: null,
      img: null,
      src: null,
      loadWatch: throttle(this.load.bind(this), 300)
    }
  },

  watch: {
    src(value) {
      this.status = value ? Status.LOADING : Status.PENDING

      this.$nextTick(() => {
        this.startDetectingLoading()
      //   const receivedSrc = this.$slots.image[0].data.attrs.src || this.$slots.image[0].data.attrs['data-src']
      //   if (this.status === Status.LOADING && !this.img) {
      //     this.createLoader()
      //   } else if (this.src !== receivedSrc) {
      //     this.src = receivedSrc
      //     this.createLoader()
      //   }
      })
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.startDetectingLoading()
    })
  },

  methods: {
    startDetectingLoading (){
      window.removeEventListener('scroll', this.loadWatch)
      window.addEventListener('scroll', this.loadWatch)
      this.load()
    },

    load () {
      if (this.isInViewport()) {
        window.removeEventListener('scroll', this.loadWatch)

        const receivedSrc = this.$slots.image[0].data.attrs.src || this.$slots.image[0].data.attrs['data-src']
        if (this.src !== receivedSrc) {
          if (this.status === Status.LOADING && !this.img) {
            this.createLoader()
          } else if (this.src !== receivedSrc) {
            this.src = receivedSrc
            this.createLoader()
          }

          this.status = receivedSrc ? Status.LOADING : Status.PENDING
        }
      }
    },

    createLoader() {
      this.destroyLoader()
      this.img = new Image()
      this.img.onload = this.handleLoad
      this.img.onerror = this.handleError
      this.img.src = this.src
    },

    destroyLoader() {
      if (this.img) {
        this.img.onload = null
        this.img.onerror = null
        this.img = null
      }
    },

    handleLoad() {
      this.destroyLoader()
      this.status = Status.LOADED
      this.$emit('onLoad')
    },

    handleError(error) {
      this.destroyLoader()
      this.status = Status.FAILED
      this.$emit('onError', error)
    },

    isInViewport() {
      const bounding = this.$el.getBoundingClientRect();

      return (
        bounding.top >= -this.$el.clientHeight &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + this.$el.clientHeight/* &&
        bounding.left >= 0 &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)*/
      );
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Core/VueLoadImage.vue